module.exports = __webpack_public_path__ + "img/key-fill.e45174fd.svg";